<script setup>
import { ref, computed } from "vue";
import { useGlobalStore } from "@stores/global.js";
import { useShopifyStore } from "@stores/shopify.js";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import Button from "@components/global/Button.vue";

const global = useGlobalStore();
const shopify = useShopifyStore();

const slider = ref({});
const breakpoints = {
	0: {
		slidesPerView: 1.2,
		spaceBetween: 8,
	},
	768: {
		slidesPerView: 2,
		spaceBetween: 8,
	},
	1024: {
		slidesPerView: 3,
		spaceBetween: 8,
	},
};

const onSwiper = (swiper) => {
	slider.value = swiper;
};

const collections = computed(() => shopify.homepageSubCollections);
</script>

<template>
	<section v-if="collections.length > 0" class="overflow-hidden py-48">
		<div class="container">
			<Swiper
				@swiper="onSwiper"
				:breakpoints="breakpoints"
				class="overflow-visible!"
			>
				<SwiperSlide v-for="collection in collections" :key="collection.id">
					<div
						@mouseenter="
							if (global.pointerFine) {
								global.setHeaderTheme(
									collection.theme?.background,
									collection.theme?.accent,
									collection.theme?.surface,
								);
								$event.currentTarget.style.setProperty('--card-accent', collection.theme?.accent);
								$event.currentTarget.style.setProperty('--card-background', collection.theme?.background);
							}
						"
						@mouseleave="
							global.setHeaderTheme(null, null, null);
							$event.currentTarget.style.removeProperty('--card-accent');
							$event.currentTarget.style.removeProperty('--card-background');
						"
						style="aspect-ratio: 0.8/1"
					>
						<div
							class="group text-text-inverted relative isolate flex aspect-[0.8/1] items-end overflow-hidden rounded-xl p-16 before:absolute before:inset-0 before:-z-1 before:size-full before:bg-linear-to-t before:from-black/50 before:to-transparent md:p-24"
						>
							<img
								:src="collection.image"
								:alt="collection.image_alt || collection.title"
								class="absolute inset-0 -z-2 size-full object-cover transition-transform duration-500 group-hover:scale-105"
							/>
							<div class="flex flex-col items-start gap-24">
								<div class="flex flex-col gap-12">
									<h2 class="h4 font-primary-condensed">
										{{ collection.title }}
									</h2>
									<p class="body-md" v-if="collection.description">
										{{ collection.description }}
									</p>
								</div>
								<Button
									:to="{
										name: 'collection',
										params: { slug: collection.slug },
									}"
									class="box-link -card-theme"
								>
									View Collection
								</Button>
							</div>
						</div>
					</div>
				</SwiperSlide>
			</Swiper>
		</div>
	</section>
</template>
